import React from "react"
import styled from "@emotion/styled"

import Layout from "../components/global/Layout"
import ButtonLink from "../components/global/ButtonLink"
import AnimatedHero from "../components/block/AnimatedHero"
import AnimatedFeature from "../components/block/AnimatedFeature"
import MediaFeature from "../components/block/MediaFeature"
import MediaFeatureCard from "../components/block/MediaFeatureCard"
import Clients from "../components/block/Clients"
import SEO from "../components/global/SEO"

const ButtonContainer = styled.div`
  display: grid;
  justify-content: flex-start;
`
const Outer = styled.section`
  display: grid;
  grid-template-columns:
    minmax(32px, auto) minmax(auto, ${props => props.theme.maxWidth})
    minmax(32px, auto);
  padding: 96px 0;
  background: ${props =>
    props.backgroundColorOverride
      ? props.backgroundColorOverride
      : "transparent"};
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    grid-template-columns: 24px auto 24px;
  }
`
const Inner = styled.div`
  grid-column: 2;
  display: grid;
  gap: 32px;
`

export default function IndexPage() {
  return (
    <div>
      <Layout>
        <SEO
          title="A Specialist User Testing Consultancy"
          description="In-depth, remote testing with real users. We help digital teams like yours avoid costly mistakes and get things right."
          image={{ src: "/opengraph.png" }}
        />
        <AnimatedHero
          title="In-depth, remote testing with real users"
          tellMeMore={true}
          description={
            <p>
              We help digital teams like yours avoid costly mistakes and get
              things right.
            </p>
          }
          image="basecamp"
        />
        <Clients />
        <AnimatedFeature />
        <Outer id="tell">
          <Inner>
            <MediaFeatureCard src="try-free">
              <h2>How we help</h2>
              <p>
                Whether you are at the design, prototype or live solution stage,
                we will help you identify, diagnose and eliminate UX issues that
                would otherwise be having a significant negative impact on your
                customer acquisition rates, conversions and sales.
              </p>
              <ButtonContainer>
                <ButtonLink
                  to="/our-user-testing/"
                  backgroundColorOverride={props => props.theme.primary}
                >
                  Our user testing
                </ButtonLink>
              </ButtonContainer>
            </MediaFeatureCard>
            <MediaFeatureCard src="get-started" reverse>
              <h2>How we work</h2>
              <p>
                Your project will be bespoke; designed to meet your business and
                solution needs specifically. We believe preparation and planning
                of research is key to generating robust insights and, we are
                particularly careful to create real-word scenarios that will
                ensure your user testing feels as true-to-life as possible.
              </p>
              <ButtonContainer>
                <ButtonLink
                  to="/how-we-do-it/"
                  backgroundColorOverride={props => props.theme.primary}
                >
                  How we do it
                </ButtonLink>
              </ButtonContainer>
            </MediaFeatureCard>
          </Inner>
        </Outer>
        <MediaFeature
          src="yha"
          backgroundColorOverride={props => props.theme.shade[90]}
          reverse
        >
          <h2>Evidence-based design </h2>
          <p>
            “The improvements that we made as a result of working with Userfy
            undoubtedly contributed to the success of the new website.”
          </p>
          <p>
            <strong>Head of Digital</strong>
          </p>
        </MediaFeature>
        <MediaFeature
          src="oakbrook"
          backgroundColorOverride={props => props.theme.shade[100]}
        >
          <h2>Optimised user journeys</h2>
          <p>
            “Not only did Userfy inform the redesign of core customer journeys,
            they were a catalyst for us to re-evaluate our customer experience
            design principles.”
          </p>
          <p>
            <strong>Chief Customer Officer</strong>
          </p>
        </MediaFeature>
        <MediaFeature
          src="tts"
          backgroundColorOverride={props => props.theme.shade[90]}
          reverse
          cta
        >
          <h2>Invaluable insights</h2>
          <p>
            “It is very easy not to find time or budget to do such an exercise,
            but they are always hugely insightful. The work we did with Userfy
            was no exception, it was invaluable.”
          </p>
          <p>
            <strong>Improvements Manager</strong>
          </p>
        </MediaFeature>
      </Layout>
    </div>
  )
}
